import React from "react";
import BasicFarmyModal from "./BasicFarmyModal";

const InfoFarmyModal = ({
                          title = null,
                          body = null,
                          onClose = () => {},
                          children,
                          modalName = "InfoFarmyModal"
                        }) => {
  return (
    <BasicFarmyModal
      onClose={onClose}
      modalName={modalName}
    >
      <h1 className={"margin-top-0 margin-bottom-10"}>{title}</h1>
      <p className={"font-family-alata margin-bottom-0"} style={{fontSize: "17px"}}>{body}</p>
      {children}
    </BasicFarmyModal>
  );
};
export default InfoFarmyModal;
